import React, { useEffect, useState } from 'react';

const SuccessOverlay = ({ show, message = "Success!", onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let closeTimer;

    if (show) {
      setVisible(true);

      // Close after 3 seconds
      closeTimer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, 2000);
    }

    return () => {
      clearTimeout(closeTimer);
    };
  }, [show]);

  if (!visible) return null;

  return (
    <div className="success-overlay">
      <div className="success-container">
        <div className="success-tick">✓</div>
        <div className="success-message">{message}</div>
      </div>
    </div>
  );
};

export default SuccessOverlay;
